import { createServerFn } from "@tanstack/react-start"
import type { InventEnvironment, InventOAuthConfig, InventRegion } from "@/lib/invent-oauth"
import {
  INVENT_OAUTH_CALLBACK_URL,
  INVENT_OAUTH_RESPONSE_TYPE,
  INVENT_OAUTH_SCOPES,
} from "../../../../lib/invent-oauth"

function parseEnvironment(value: string | undefined): InventEnvironment | null {
  return value === "development" || value === "integration" || value === "production" ? value : null
}

function parseRegion(value: string | undefined): InventRegion | null {
  return value === "ca" || value === "us" ? value : null
}

export function readInventOAuthConfig(
  environment: Record<string, string | undefined>,
): InventOAuthConfig | null {
  const envName = parseEnvironment(environment.ENV_NAME)
  const region = parseRegion(environment.REGION)
  const peaClientId = environment.INVENT_PEA_OAUTH_CLIENT_ID
  const authorizationBase = environment.INVENT_COGNITO_AUTHORIZATION_BASE

  if (!envName || !region || !peaClientId || !authorizationBase) {
    return null
  }

  return {
    environment: envName,
    region,
    peaClientId,
    authorizationBase,
    callbackUrl: INVENT_OAUTH_CALLBACK_URL,
    responseType: INVENT_OAUTH_RESPONSE_TYPE,
    scopes: INVENT_OAUTH_SCOPES,
  }
}

export const getInventOAuthConfig = createServerFn({ method: "GET" }).handler(async () =>
  readInventOAuthConfig(process.env),
)
